import { render, staticRenderFns } from "./capAccountDetail.vue?vue&type=template&id=ddfc287c&scoped=true&"
import script from "./capAccountDetail.vue?vue&type=script&lang=js&"
export * from "./capAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./capAccountDetail.vue?vue&type=style&index=0&id=ddfc287c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc287c",
  null
  
)

export default component.exports